import { Injectable } from "@angular/core";
import { OntologyAnnotation } from "@bioconnect-ui/curation-service";
import { DataSchema, FieldDescriptor } from "@bioconnect-ui/structured-data-service"

export interface BioSampleServiceConfig {
  restServer: string;
}

export interface SampleSheetTemplate {
  id?: number;
  name: string;
  description?: string;
  measurement_type?: OntologyAnnotation;
  measurement_type_id?: number;
  data_schema?: DataSchema;
  data_schema_id?: number;
  field_descriptors?: FieldDescriptor[];
}

@Injectable({
  providedIn: 'root',
})
export class BioSampleServiceTypes{}